// extracted by mini-css-extract-plugin
export default {"SummaryTotalPriceComponent":"SummaryTotalPriceComponent_k13fu","SummaryTotalPriceComponent__pricing":"SummaryTotalPriceComponent__pricing_ZSAZA"};